(()=>{
 'use strict';
 let dispose=null;
 function mount(){
  const root=document.getElementById('lexip-criminal-root');
  if(!root)return;
  if(dispose)dispose();
  dispose=(()=>{
   const cleanup=[],timers=new Set(),frames=new Set();
   const on=(target,event,listener,options)=>{target.addEventListener(event,listener,options);cleanup.push(()=>target.removeEventListener(event,listener,options));};
   const setTimeout=(callback,delay)=>{const id=window.setTimeout(()=>{timers.delete(id);callback();},delay);timers.add(id);return id;};
   const clearTimeout=id=>{timers.delete(id);window.clearTimeout(id);};
   const requestAnimationFrame=callback=>{const id=window.requestAnimationFrame(time=>{frames.delete(id);callback(time);});frames.add(id);return id;};
   const cancelAnimationFrame=id=>{frames.delete(id);window.cancelAnimationFrame(id);};
   const ResizeObserver=class extends window.ResizeObserver{constructor(callback){super(callback);cleanup.push(()=>this.disconnect());}};
   const IntersectionObserver=class extends window.IntersectionObserver{constructor(callback,options){super(callback,options);cleanup.push(()=>this.disconnect());}};
   const MutationObserver=class extends window.MutationObserver{constructor(callback){super(callback);cleanup.push(()=>this.disconnect());}};
   const locale=JSON.parse(document.getElementById('lexip-criminal-translations').textContent);
   const L=key=>(locale[key]||key).replace(/&(?:amp|quot|apos|lt|gt|#39|#x27);/g,entity=>({'&amp;':'&','&quot;':'"','&apos;':"'",'&lt;':'<','&gt;':'>','&#39;':"'",'&#x27;':"'"}[entity]));
'use strict';
const products = JSON.parse(document.getElementById('product-data').textContent);
const assetBase = "";
const config = JSON.parse(document.getElementById("lexip-criminal-config").textContent);
const productAsset = file => file;
const currentViews = Object.fromEntries(products.map(p => [p.key, 0]));
let chosen = 'manette-violet';
function displayProduct(key, focus = false) {
    const product = products.find(p => p.key === key);
    if (!product)
        return;
    chosen = key;
    document.querySelectorAll('[data-product]').forEach(el => el.hidden = el.dataset.product !== key);
    document.querySelectorAll('[data-card]').forEach(el => { if (el.dataset.card === key)
        el.setAttribute('aria-current', 'true');
    else
        el.removeAttribute('aria-current'); });
    document.querySelectorAll('.picker-link').forEach(el => { if (el.dataset.select === key)
        el.setAttribute('aria-current', 'true');
    else
        el.removeAttribute('aria-current'); });
    document.getElementById('selection-status').textContent = L("s_496ef5caf032") + product.name + ' · ' + product.images[currentViews[key]][1];
    if (focus) {
        document.getElementById('explorer').scrollIntoView({ block: 'start', behavior: 'instant' });
        document.getElementById('titre-' + key).focus({ preventScroll: true });
    }
}
function route(focus = false) { const key = location.hash.slice(1); if (products.some(p => p.key === key))
    displayProduct(key, focus);
else if (!location.hash)
    displayProduct('manette-violet', false); }
document.querySelectorAll('[data-select]').forEach(a => on(a, 'click', event => { event.preventDefault(); if (location.hash !== a.hash)
    history.pushState(null, '', a.hash); displayProduct(a.dataset.select, true); }));
document.querySelectorAll('[data-product-view]').forEach(button => on(button, 'click', () => {
    const key = button.dataset.productView, p = products.find(p => p.key === key), i = Number(button.dataset.view), im = p.images[i];
    currentViews[key] = i;
    const image = document.getElementById('image-' + key);
    image.srcset = i === 0 ? (image.dataset.defaultSrcset || '') : '';
    image.src = productAsset(im[0]);
    image.alt = im[2];
    document.getElementById('legende-' + key).textContent = p.name + ' · ' + im[1];
    document.querySelectorAll('[data-product-view="' + key + '"]').forEach(el => el.setAttribute('aria-pressed', String(Number(el.dataset.view) === i)));
    if (chosen === key)
        document.getElementById('selection-status').textContent = L("s_496ef5caf032") + p.name + ' · ' + im[1];
}));
displayProduct(chosen);
route();
on(window, 'hashchange', () => route(true));
on(window, 'popstate', () => route(true));
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
if (!reduced.matches && 'IntersectionObserver' in window) {
    document.body.classList.add('motion');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) {
        entry.target.classList.remove('waiting');
        observer.unobserve(entry.target);
    } }), { threshold: .08 });
    document.querySelectorAll('.reveal').forEach(el => { el.classList.add('waiting'); observer.observe(el); });
    on(reduced, 'change', event => { if (event.matches) {
        document.body.classList.remove('motion');
        document.querySelectorAll('.waiting').forEach(el => el.classList.remove('waiting'));
        observer.disconnect();
    } });
}
const toggle = document.getElementById('radio-toggle'), volume = document.getElementById('radio-volume'), radioState = document.getElementById('radio-state');
const radioPlaylist = [{ "title": L("s_cc562a19411c"), "file": "criminal-fm.m4a" }, { "title": L("s_f7478873509d"), "file": "media/velvet-afterglow.m4a" }, { "title": L("s_375fc0fae9bc"), "file": "media/palm-boulevard.m4a" }, { "title": L("s_15847ac6a23a"), "file": "media/midnight-valet.m4a" }, { "title": L("s_f1567eb7aac4"), "file": "media/gold-coast-hustle.m4a" }, { "title": L("s_8720a87d3196"), "file": "media/neon-confession.m4a" }, { "title": L("s_c27496b6773c"), "file": "media/last-call-mirage.m4a" }];
const radioChoice = document.getElementById('radio-track-select');
let radioIndex = 0, radioAction = 0;
const radioTrack = document.createElement('audio');
radioTrack.id = 'criminal-radio-audio';
radioTrack.src = config.radio[0].url;
radioTrack.preload = 'none';
radioTrack.loop = false;
radioTrack.volume = Number(volume.value) / 100;
radioTrack.setAttribute('aria-hidden', 'true');
document.body.append(radioTrack);
function uiAudio() {
    const active = !radioTrack.paused && !radioTrack.ended && !radioTrack.error;
    toggle.setAttribute('aria-pressed', String(active));
    toggle.setAttribute('aria-label', active ? L("s_fe0b0021d623") : L("s_fd2fcdc26991"));
    document.getElementById('radio-label').textContent = active ? L("s_42dd586c06d6") : L("s_9da78f5ef72d");
    toggle.querySelector('svg').innerHTML = active ? '<path d="M7 5h4v14H7zm6 0h4v14h-4z" fill="currentColor"/>' : '<path d="m8 5 11 7-11 7z" fill="currentColor"/>';
    document.body.classList.toggle('audio-playing', active);
    radioState.textContent = radioPlaylist[radioIndex].title + (active ? L("s_c36e9b4d9d68") : L("s_db7e74131c1f"));
    document.getElementById('radio-track-name').textContent = radioPlaylist[radioIndex].title;
    radioChoice.value = String(radioIndex);
    toggle.dataset.audioState = active ? 'running' : radioTrack.currentTime > 0 ? 'paused' : 'idle';
    const head = document.getElementById('header-radio');
    head.setAttribute('aria-pressed', String(active));
    head.removeAttribute('aria-label');
    head.title = radioPlaylist[radioIndex].title;
    document.getElementById('header-radio-state').textContent = active ? L("s_a0db9cb61906") : L("s_5be4fcb6fb5e");
}
function radioError() {
    radioTrack.pause();
    uiAudio();
    radioState.textContent = L("s_1369cdfe3e53");
    document.getElementById('header-radio-state').textContent = L("s_9143816d8523");
}
function pauseRadio() { radioAction++; radioTrack.pause(); uiAudio(); }
async function startRadio() {
    const action = ++radioAction;
    try {
        await radioTrack.play();
        if (action === radioAction)
            uiAudio();
    }
    catch (error) {
        if (action === radioAction && error.name !== 'AbortError')
            radioError();
    }
}
function setRadioTrack(index, resume = !radioTrack.paused) {
    pauseRadio();
    radioIndex = (index + radioPlaylist.length) % radioPlaylist.length;
    radioTrack.src = config.radio[radioIndex].url;
    radioTrack.load();
    uiAudio();
    if (resume)
        startRadio();
}
on(toggle, 'click', () => { if (!radioTrack.paused)
    pauseRadio();
else
    startRadio(); });
on(radioChoice, 'change', () => { const index = Number(radioChoice.value); if (Number.isInteger(index) && index >= 0 && index < radioPlaylist.length && index !== radioIndex)
    setRadioTrack(index); });
on(volume, 'input', () => { radioTrack.volume = Number(volume.value) / 100; });
for (const event of ['play', 'playing', 'pause'])
    on(radioTrack, event, uiAudio);
on(radioTrack, 'ended', () => { if (!document.hidden)
    setRadioTrack(radioIndex + 1, true); });
on(radioTrack, 'error', radioError);
on(document, 'visibilitychange', () => { if (document.hidden)
    pauseRadio(); });
on(window, 'pagehide', pauseRadio);
uiAudio();
on(document.getElementById('header-radio'), 'click', () => { if (config.radioEnabled)
    document.getElementById('radio-toggle').click(); });
let syncHeroCommerce;
if (config.commerceEnabled) {
    const cartDialog = document.getElementById('cart-dialog'), cartItems = document.getElementById('cart-items'), cartCount = document.getElementById('cart-count'), cartTotal = document.getElementById('cart-total'), cartStatus = document.getElementById('cart-status'), cartFinish = document.getElementById('cart-finish');
    let cartReturn = null, cartBusy = false, storeCart = null;
    const formatMoney = cents => new Intl.NumberFormat(config.locale || 'fr-FR', { style: 'currency', currency: config.currency }).format(cents / 100);
    syncHeroCommerce = function (product) {
        const form = document.getElementById('hero-product-form'), button = document.getElementById('hero-preorder');
        form.dataset.productKey = product.key;
        form.querySelector('[name="id"]').value = product.variantId || '';
        button.disabled = cartBusy || !product.canBuy;
        button.setAttribute('aria-label', product.canBuy ? config.buyLabel + ' ' + product.name : product.ready && product.available === false ? L("s_00b08673462f") + product.name : L("s_5ae4aa06b578") + product.name);
        document.getElementById('hero-preorder-label').textContent = product.canBuy ? config.buyLabel + ' ' + product.model : product.ready && product.available === false ? 'Indisponible' : L("s_96ffb52d9b20");
        document.querySelector('#hero-price .price').textContent = product.priceFormatted;
        document.querySelector('#hero-price .price-note').textContent = product.priceNote;
    };
    function renderCart(data) {
        storeCart = data;
        cartItems.replaceChildren();
        cartCount.textContent = String(data.item_count);
        cartTotal.textContent = formatMoney(data.total_price);
        for (const item of data.items) {
            const row = document.createElement('article');
            row.className = 'cart-row';
            if (item.image) {
                const img = document.createElement('img');
                img.src = item.image;
                img.alt = item.product_title;
                img.width = 65;
                img.height = 65;
                row.append(img);
            }
            const copy = document.createElement('div'), title = document.createElement('h3'), price = document.createElement('p'), controls = document.createElement('div');
            title.textContent = item.product_title;
            price.textContent = formatMoney(item.final_line_price);
            controls.className = 'quantity';
            const minus = document.createElement('button'), value = document.createElement('span'), plus = document.createElement('button'), remove = document.createElement('button');
            minus.type = plus.type = remove.type = 'button';
            minus.textContent = '−';
            plus.textContent = '+';
            remove.textContent = L('s_9f25cc947f93').trim().replace(/:$/, '');
            value.textContent = String(item.quantity);
            minus.setAttribute('aria-label', L("s_f415d8988812") + item.product_title);
            plus.setAttribute('aria-label', L("s_db08226b6646") + item.product_title);
            remove.setAttribute('aria-label', L("s_9f25cc947f93") + item.product_title);
            for (const button of [minus, plus, remove])
                button.disabled = cartBusy || !config.commerceEnabled;
            on(minus, 'click', () => changeCart(item.key, item.quantity - 1));
            on(plus, 'click', () => changeCart(item.key, item.quantity + 1));
            on(remove, 'click', () => changeCart(item.key, 0));
            controls.append(minus, value, plus, remove);
            copy.append(title, price, controls);
            row.append(copy);
            cartItems.append(row);
        }
        if (!data.items.length) {
            const empty = document.createElement('p');
            empty.className = 'cart-empty';
            empty.textContent = L("s_17d2610a17e6");
            cartItems.append(empty);
        }
        cartFinish.disabled = cartBusy || !config.commerceEnabled || data.item_count === 0;
        document.getElementById('cart-open').setAttribute('aria-label', L("s_c2d0b7add2d2") + data.item_count + L("s_76080686fd83"));
    }
    function setCartBusy(busy) {
        cartBusy = busy;
        cartDialog.setAttribute('aria-busy', String(busy));
        document.querySelectorAll('[data-preorder]').forEach(button => { const product = products.find(p => p.key === button.dataset.preorder); button.disabled = busy || !product?.canBuy; });
        cartFinish.disabled = busy || !config.commerceEnabled || !storeCart?.item_count;
        if (storeCart)
            renderCart(storeCart);
    }
    async function cartRequest(url, body) {
        const response = await fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
        let data;
        try {
            data = await response.json();
        }
        catch {
            throw new Error(L("s_5843f98e1480"));
        }
        if (!response.ok)
            throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : L("s_386e1cacfd84"));
        return data;
    }
    function openCart(trigger) { cartReturn = trigger; if (!cartDialog.open)
        cartDialog.showModal(); document.getElementById('cart-close').focus(); }
    async function refreshCart() { const data = await cartRequest(config.cartJsonUrl); renderCart(data); return data; }
    async function changeCart(key, quantity) {
        if (cartBusy || !config.commerceEnabled)
            return;
        setCartBusy(true);
        try {
            renderCart(await cartRequest(config.changeUrl, { id: key, quantity }));
            cartStatus.textContent = L("s_1fcfa6d921e6");
            document.getElementById('cart-close').focus();
        }
        catch (error) {
            cartStatus.textContent = error.message;
        }
        finally {
            setCartBusy(false);
        }
    }
    on(document.getElementById('cart-open'), 'click', async (event) => {
        openCart(event.currentTarget);
        cartStatus.textContent = L("s_5899693bdb34");
        try {
            await refreshCart();
            cartStatus.textContent = '';
        }
        catch (error) {
            cartStatus.textContent = error.message;
        }
    });
    document.querySelectorAll('[data-criminal-product-form]').forEach(form => on(form, 'submit', async (event) => {
        event.preventDefault();
        if (cartBusy || !config.commerceEnabled)
            return;
        const product = products.find(p => p.key === form.dataset.productKey), id = Number(form.querySelector('[name="id"]').value);
        if (!product?.canBuy || !id || id !== Number(product.variantId))
            return;
        setCartBusy(true);
        openCart(form.querySelector('button'));
        cartStatus.textContent = L("s_847fc20d1043");
        try {
            await cartRequest(config.addUrl, { items: [{ id, quantity: 1 }] });
            await refreshCart();
            cartStatus.textContent = product.name + L("s_a3be2e782cf1");
        }
        catch (error) {
            cartStatus.textContent = error.message;
        }
        finally {
            setCartBusy(false);
        }
    }));
    for (const id of ['cart-close', 'cart-continue'])
        on(document.getElementById(id), 'click', () => cartDialog.close());
    on(cartDialog, 'close', () => { if (cartReturn?.isConnected)
        cartReturn.focus(); });
    on(cartDialog, 'keydown', event => {
        if (event.key !== 'Tab')
            return;
        const controls = [...cartDialog.querySelectorAll('button:not(:disabled),a[href]')].filter(el => el.getClientRects().length), first = controls[0], last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        }
        else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });
    on(document, 'visibilitychange', () => { if (!document.hidden && !cartBusy)
        refreshCart().catch(() => { }); });
    on(document.getElementById('criminal-checkout'), 'submit', event => { if (!config.commerceEnabled || cartBusy || !storeCart?.item_count)
        event.preventDefault(); });
    renderCart({ items: [], item_count: 0, total_price: 0 });
    refreshCart().catch(() => { });
}
else {
    const cartDialog = document.getElementById('cart-dialog'), cartItems = document.getElementById('cart-items'), cartCount = document.getElementById('cart-count'), cartTotal = document.getElementById('cart-total'), cartStatus = document.getElementById('cart-status'), cartFinish = document.getElementById('cart-finish');
    const cart = new Map();
    let cartReturn = null;
    const formatMoney = cents => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    function renderCart() {
        cartItems.replaceChildren();
        let total = 0, count = 0;
        for (const [key, quantity] of cart) {
            const product = products.find(p => p.key === key);
            total += product.priceCents * quantity;
            count += quantity;
            const row = document.createElement('article');
            row.className = 'cart-row';
            row.dataset.cartProduct = key;
            const image = document.createElement('img');
            image.src = productAsset(product.images[0][0]);
            image.alt = product.name;
            image.width = 65;
            image.height = 65;
            const copy = document.createElement('div'), title = document.createElement('h3'), priceText = document.createElement('p'), controls = document.createElement('div');
            title.textContent = product.name;
            priceText.textContent = formatMoney(product.priceCents) + L("s_6fd2641007d5");
            controls.className = 'quantity';
            const minus = document.createElement('button'), value = document.createElement('span'), plus = document.createElement('button'), remove = document.createElement('button');
            minus.type = plus.type = remove.type = 'button';
            minus.textContent = '−';
            plus.textContent = '+';
            remove.textContent = L('s_9f25cc947f93').trim().replace(/:$/, '');
            value.textContent = String(quantity);
            value.setAttribute('aria-label', L("s_c8b3c2f2358f") + quantity);
            minus.setAttribute('aria-label', L("s_f415d8988812") + product.name);
            plus.setAttribute('aria-label', L("s_db08226b6646") + product.name);
            remove.setAttribute('aria-label', L("s_9f25cc947f93") + product.name);
            function change(delta) { const next = (cart.get(key) || 0) + delta; if (next <= 0)
                cart.delete(key);
            else
                cart.set(key, Math.min(next, 99)); cartStatus.textContent = product.name + ' : ' + (cart.get(key) || 0) + L("s_a1e0b66926fe"); renderCart(); const matching = [...cartItems.querySelectorAll('[data-cart-product]')].find(el => el.dataset.cartProduct === key); if (matching) {
                matching.querySelector(delta > 0 ? 'button:nth-of-type(2)' : 'button').focus();
            }
            else
                document.getElementById('cart-close').focus(); }
            on(minus, 'click', () => change(-1));
            on(plus, 'click', () => change(1));
            on(remove, 'click', () => { cart.delete(key); renderCart(); cartStatus.textContent = product.name + L("s_5446142ee4d8"); document.getElementById('cart-close').focus(); });
            controls.append(minus, value, plus, remove);
            copy.append(title, priceText, controls);
            row.append(image, copy);
            cartItems.append(row);
        }
        if (count === 0) {
            const empty = document.createElement('p');
            empty.className = 'cart-empty';
            empty.textContent = L("s_17d2610a17e6");
            cartItems.append(empty);
        }
        cartCount.textContent = String(count);
        cartTotal.textContent = formatMoney(total);
        cartFinish.disabled = count === 0;
        document.getElementById('cart-open').setAttribute('aria-label', L("s_3446990b28c8") + count + L("s_4b0888cd0716") + (count > 1 ? 's' : ''));
    }
    function openCart(trigger) { cartReturn = trigger; cartDialog.showModal(); document.getElementById('cart-close').focus(); }
    on(document.getElementById('cart-open'), 'click', event => { cartStatus.textContent = ''; renderCart(); openCart(event.currentTarget); });
    document.querySelectorAll('[data-preorder]').forEach(button => on(button, 'click', () => { const key = button.dataset.preorder; cart.set(key, Math.min((cart.get(key) || 0) + 1, 99)); renderCart(); cartStatus.textContent = products.find(p => p.key === key).name + L("s_d62d0cc06377"); openCart(button); }));
    for (const id of ['cart-close', 'cart-continue'])
        on(document.getElementById(id), 'click', () => cartDialog.close());
    on(cartDialog, 'close', () => { if (cartReturn?.isConnected)
        cartReturn.focus(); });
    on(cartDialog, 'keydown', event => { if (event.key !== 'Tab')
        return; const buttons = [...cartDialog.querySelectorAll('button:not(:disabled)')], first = buttons[0], last = buttons.at(-1); if (!first)
        return; if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
    }
    else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
    } });
    on(cartFinish, 'click', () => { cartStatus.textContent = L("s_55e11f8337d3"); });
    renderCart();
}
const heroControllers = ['manette-violet', 'manette-black'];
let heroIndex = 1;
let heroReady = false, heroMotion = [];
function stopHeroMotion() {
    heroMotion.forEach(animation => animation.cancel());
    heroMotion = [];
    document.querySelector('.hero').dataset.switchState = 'settled';
}
on(reduced, 'change', event => { if (event.matches)
    stopHeroMotion(); });
let heroChoiceLocked = false;
function setHero(index, sync = true, automatic = false) {
    if (heroReady && !automatic) {
        heroChoiceLocked = true;
        const setting = document.getElementById("hero-auto-setting");
        if (setting)
            setting.checked = false;
    }
    const previous = heroIndex;
    document.querySelector('.hero-model').setAttribute('aria-live', automatic ? 'off' : 'polite');
    heroIndex = (index + heroControllers.length) % heroControllers.length;
    const key = heroControllers[heroIndex], product = products.find(p => p.key === key), violet = key === 'manette-violet';
    document.querySelector('.hero').dataset.controller = key;
    document.body.dataset.controller = key;
    for (const name of ['violet', 'black']) {
        const active = (name === 'violet') === violet;
        const city = document.getElementById('hero-city-' + name);
        city.classList.toggle('is-active', active);
        city.setAttribute('aria-hidden', String(!active));
    }
    document.querySelectorAll('[data-hero-controller]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.heroController === key)));
    for (const name of ['violet', 'black']) {
        const image = document.getElementById('hero-scene-' + name), active = (name === 'violet') === violet;
        image.classList.toggle('is-active', active);
        image.setAttribute('aria-hidden', String(!active));
    }
    document.getElementById('hero-model-name').textContent = violet ? 'Sunset' : 'Gangsta';
    document.getElementById('hero-model-detail').textContent = violet ? L("s_07527278e0a0") : L("s_0820bce87ef2");
    const button = document.getElementById('hero-preorder');
    button.dataset.preorder = key;
    if (config.commerceEnabled) {
        syncHeroCommerce(product);
    }
    else {
        button.removeAttribute('aria-label');
        document.getElementById('hero-preorder-label').textContent = L("s_41761410f574") + (violet ? 'Sunset' : 'Gangsta');
    }
    if (sync && !automatic)
        displayProduct(key, false);
    const hero = document.querySelector('.hero');
    hero.querySelectorAll('[data-scenery]').forEach(layer => layer.classList.toggle('is-active', layer.dataset.scenery === key));
    if (heroReady && previous !== heroIndex) {
        stopHeroMotion();
        if (!reduced.matches) {
            const incoming = document.getElementById('hero-city-' + (violet ? 'violet' : 'black'));
            hero.dataset.switchState = 'switching';
            const animation = incoming.animate([{ transform: 'translateX(' + (violet ? -24 : 24) + 'px)' }, { transform: 'translateX(0)' }], { duration: 650, easing: 'cubic-bezier(.22,1,.36,1)' });
            heroMotion = [animation];
            animation.finished.then(() => { if (heroMotion.includes(animation)) {
                heroMotion = [];
                hero.dataset.switchState = 'settled';
            } }, () => { });
        }
    }
    if (!heroReady) {
        heroReady = true;
        hero.dataset.switchState = 'settled';
        requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('switch-ready')));
    }
}
document.querySelectorAll('[data-hero-controller]').forEach(button => on(button, 'click', () => setHero(heroControllers.indexOf(button.dataset.heroController))));
on(document.getElementById('hero-switch'), 'keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    setHero(heroIndex + (event.key === 'ArrowRight' ? 1 : -1));
    document.querySelector('[data-hero-controller="' + heroControllers[heroIndex] + '"]').focus();
} });
const heroSection = document.querySelector('.hero');
let swipeStart = null;
on(heroSection, 'pointerdown', event => { if (event.target.closest('button,a,input'))
    return; swipeStart = { x: event.clientX, y: event.clientY }; });
on(heroSection, 'pointerup', event => { if (!swipeStart)
    return; const dx = event.clientX - swipeStart.x, dy = event.clientY - swipeStart.y; swipeStart = null; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5)
    setHero(heroIndex + (dx < 0 ? 1 : -1)); });
on(heroSection, 'pointercancel', () => swipeStart = null);
const linked = location.hash.slice(1);
setHero(linked === 'manette-violet' ? 0 : 1, !products.some(p => p.key === linked));
const widget = document.getElementById('radio-widget'), settings = document.getElementById('radio-settings'), widgetPanel = document.getElementById('radio-widget-panel'), widgetVolume = document.getElementById('widget-volume');
function closeWidget() { widgetPanel.hidden = true; settings.setAttribute('aria-expanded', 'false'); }
on(settings, 'click', () => { const open = widgetPanel.hidden; widgetPanel.hidden = !open; settings.setAttribute('aria-expanded', String(open)); });
on(widgetVolume, 'input', () => { volume.value = widgetVolume.value; volume.dispatchEvent(new Event('input', { bubbles: true })); });
on(volume, 'input', () => { widgetVolume.value = volume.value; });
on(document, 'click', event => { if (event.isTrusted && !widget.contains(event.target))
    closeWidget(); });
on(widget, 'keydown', event => { if (event.key === 'Escape' && !widgetPanel.hidden) {
    event.preventDefault();
    closeWidget();
    settings.focus();
} });
let heroAutoTimer = null;
let heroInView = heroSection.getBoundingClientRect().bottom > 0 && heroSection.getBoundingClientRect().top < innerHeight;
function scheduleHeroAuto() {
    clearTimeout(heroAutoTimer);
    heroAutoTimer = null;
    if (config.designMode || heroChoiceLocked || reduced.matches || document.hidden || !heroInView)
        return;
    heroAutoTimer = setTimeout(() => {
        if (!heroChoiceLocked && !document.querySelector('dialog[open]'))
            setHero(heroIndex + 1, true, true);
        scheduleHeroAuto();
    }, 4000);
}
on(heroSection, 'click', event => { if (event.target.closest('[data-hero-controller]'))
    scheduleHeroAuto(); });
on(heroSection, 'keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight')
    scheduleHeroAuto(); });
on(heroSection, 'pointerup', scheduleHeroAuto);
on(document, 'visibilitychange', scheduleHeroAuto);
on(window, 'pagehide', () => clearTimeout(heroAutoTimer));
on(window, 'pageshow', scheduleHeroAuto);
on(reduced, 'change', scheduleHeroAuto);
if ('IntersectionObserver' in window) {
    const heroAutoObserver = new IntersectionObserver(entries => { heroInView = entries[0].isIntersecting; scheduleHeroAuto(); }, { threshold: 0 });
    heroAutoObserver.observe(heroSection);
}
scheduleHeroAuto();
const heroAutoSetting = document.getElementById('hero-auto-setting');
function motionSetting() { heroAutoSetting.disabled = reduced.matches; heroAutoSetting.checked = !reduced.matches && !heroChoiceLocked; }
on(heroAutoSetting, 'change', () => { heroChoiceLocked = !heroAutoSetting.checked; scheduleHeroAuto(); });
on(reduced, 'change', motionSetting);
motionSetting();
'use strict';
(() => {
    const data = JSON.parse(document.getElementById('city-data').textContent), viewport = document.getElementById('city-viewport'), world = document.getElementById('city-world');
    const pins = [...document.querySelectorAll('[data-place]')], filters = [...document.querySelectorAll('[data-city-filter]')], picker = document.getElementById('city-place-select'), routeButton = document.getElementById('city-route-toggle'), route = document.getElementById('city-route'), status = document.getElementById('city-route-status');
    let selected = data[0], filter = 'all', routeShown = false, width = 0, height = 0, base = 1, zoom = 1, cx = 600, cy = 420, initialized = false, drag = null, frame = null;
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    function render() {
        const scale = base * zoom;
        cx = 1200 * scale > width ? clamp(cx, width / (2 * scale), 1200 - width / (2 * scale)) : 600;
        cy = 840 * scale > height ? clamp(cy, height / (2 * scale), 840 - height / (2 * scale)) : 420;
        const tx = width / 2 - cx * scale, ty = height / 2 - cy * scale;
        world.style.transform = 'translate(' + tx + 'px,' + ty + L("s_02d041ce5523") + scale + ')';
        for (const button of pins) {
            const place = data.find(p => p.id === button.dataset.place);
            button.style.left = (tx + place.x * scale) + 'px';
            button.style.top = (ty + place.y * scale) + 'px';
        }
        viewport.dataset.ready = 'true';
        document.getElementById('city-zoom-in').disabled = zoom >= 2.6;
        document.getElementById('city-zoom-out').disabled = zoom <= .5;
    }
    function paint() { if (frame === null)
        frame = requestAnimationFrame(() => { frame = null; render(); }); }
    function resize() {
        const wasMobile = width < 600;
        width = viewport.clientWidth;
        height = viewport.clientHeight;
        base = Math.max(width / 1200, height / 840);
        if (!initialized) {
            if (width < 600) {
                cx = 890;
                cy = 360;
                zoom = 1;
            }
            else
                overview(false);
            initialized = true;
        }
        else if (routeShown) {
            frameRoute();
            return;
        }
        else if (wasMobile !== (width < 600)) {
            cx = selected.x;
            cy = selected.y;
            zoom = 1;
        }
        render();
    }
    function overview(draw = true) { cx = 600; cy = 420; zoom = clamp(Math.min(width / 1200, height / 840) / base * .94, .5, 2.6); if (draw)
        render(); }
    function center(place) { cx = place.x; cy = place.y; render(); }
    function routePoints(place) {
        const xs = [120, 280, 440, 600, 760], ys = [60, 180, 300, 420, 540, 660, 780], nodes = new Map();
        const key = (x, y) => x + ',' + y;
        for (const x of [...xs, 1040])
            for (const y of ys)
                nodes.set(key(x, y), { x, y, neighbors: [] });
        function edge(x1, y1, x2, y2) { const a = nodes.get(key(x1, y1)), b = nodes.get(key(x2, y2)); a.neighbors.push(b); b.neighbors.push(a); }
        for (const x of [...xs, 1040])
            for (let j = 0; j < ys.length - 1; j++)
                edge(x, ys[j], x, ys[j + 1]);
        for (const y of ys)
            for (let j = 0; j < xs.length - 1; j++)
                edge(xs[j], y, xs[j + 1], y);
        edge(760, 300, 1040, 300);
        edge(760, 540, 1040, 540);
        const start = key(280, 660), end = key(place.x, place.y), dist = new Map([[start, 0]]), previous = new Map(), remaining = new Set(nodes.keys());
        while (remaining.size) {
            let current = null, best = Infinity;
            for (const id of remaining) {
                const d = dist.get(id) ?? Infinity;
                if (d < best) {
                    best = d;
                    current = id;
                }
            }
            if (current === null || current === end)
                break;
            remaining.delete(current);
            const node = nodes.get(current);
            for (const next of node.neighbors) {
                const id = key(next.x, next.y), cost = best + Math.hypot(next.x - node.x, next.y - node.y);
                if (cost < (dist.get(id) ?? Infinity)) {
                    dist.set(id, cost);
                    previous.set(id, current);
                }
            }
        }
        const points = [];
        let current = end;
        while (current) {
            points.unshift(nodes.get(current));
            if (current === start)
                break;
            current = previous.get(current);
        }
        return points;
    }
    function drawRoute() {
        route.classList.toggle('is-visible', routeShown);
        routeButton.setAttribute('aria-pressed', String(routeShown));
        routeButton.firstChild.textContent = routeShown ? L("s_8b7f64e57c80") : L("s_47f4a30282b0");
        if (!routeShown) {
            status.textContent = '';
            return;
        }
        const points = routePoints(selected), d = points.map((point, index) => (index ? 'L' : 'M') + point.x + ' ' + point.y).join(' ');
        document.getElementById('city-route-line').setAttribute('d', d);
        document.getElementById('city-route-under').setAttribute('d', d);
        status.textContent = selected.id === 'le-refuge' ? L("s_d88f883a7422") : L("s_2f937649da3d") + selected.name;
    }
    function frameRoute() {
        if (selected.id === 'le-refuge') {
            overview();
            return;
        }
        const points = routePoints(selected), xs = points.map(p => p.x), ys = points.map(p => p.y), minX = Math.min(...xs), maxX = Math.max(...xs), minY = Math.min(...ys), maxY = Math.max(...ys);
        cx = (minX + maxX) / 2;
        cy = (minY + maxY) / 2;
        zoom = clamp(Math.min((width - 130) / Math.max(160, maxX - minX), (height - 130) / Math.max(160, maxY - minY)) / base, .5, 1.6);
        render();
    }
    function selectPlace(id, recenter = true) {
        const next = data.find(p => p.id === id);
        if (!next)
            return;
        selected = next;
        for (const button of pins)
            button.setAttribute('aria-pressed', String(button.dataset.place === id));
        picker.value = id;
        for (const [target, value] of Object.entries({ 'city-place-name': next.name, 'city-place-type': next.district + ' · ' + next.type, 'city-tagline': next.tagline, 'city-description': next.description, 'city-mood': next.mood }))
            document.getElementById(target).textContent = value;
        document.getElementById('city-venue-art').dataset.kind = next.kind;
        const activeIcon = document.querySelector('[data-place="' + id + L("s_4261704a628a"));
        document.getElementById('city-art-icon').replaceChildren(activeIcon.cloneNode(true));
        drawRoute();
        if (recenter) {
            if (routeShown)
                frameRoute();
            else
                center(next);
        }
        document.dispatchEvent(new CustomEvent('city:placechange', { detail: { id: next.id, kind: next.kind } }));
    }
    function setFilter(value) {
        filter = value;
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cityFilter === value)));
        const visible = data.filter(place => value === 'all' || place.kind === value);
        pins.forEach(button => button.hidden = value !== 'all' && button.dataset.kind !== value);
        picker.replaceChildren(...visible.map(place => { const option = document.createElement('option'); option.value = place.id; option.textContent = place.name; return option; }));
        document.getElementById('city-place-count').textContent = visible.length + L("s_5c8b1e159a69") + (visible.length > 1 ? 'x' : '');
        if (!visible.some(place => place.id === selected.id))
            selectPlace(visible[0].id);
        else
            picker.value = selected.id;
    }
    pins.forEach(button => on(button, 'click', () => selectPlace(button.dataset.place)));
    filters.forEach(button => on(button, 'click', () => setFilter(button.dataset.cityFilter)));
    on(picker, 'change', () => selectPlace(picker.value));
    on(document, 'city:navigate', event => {
        const request = event.detail;
        if (!request || !data.some(place => place.id === request.id))
            return;
        setFilter('all');
        routeShown = Boolean(request.route);
        selectPlace(request.id);
    });
    on(routeButton, 'click', () => { routeShown = !routeShown; drawRoute(); if (routeShown)
        frameRoute(); });
    function changeZoom(factor) { zoom = clamp(zoom * factor, .5, 2.6); render(); }
    on(document.getElementById('city-zoom-in'), 'click', () => changeZoom(1.25));
    on(document.getElementById('city-zoom-out'), 'click', () => changeZoom(.8));
    on(document.getElementById('city-reset'), 'click', () => overview());
    on(viewport, 'pointerdown', event => { if (event.target.closest('button') || event.button !== 0)
        return; drag = { id: event.pointerId, x: event.clientX, y: event.clientY, cx, cy }; viewport.setPointerCapture(event.pointerId); viewport.classList.add('is-dragging'); });
    on(viewport, 'pointermove', event => { if (!drag || event.pointerId !== drag.id)
        return; const scale = base * zoom; cx = clamp(drag.cx - (event.clientX - drag.x) / scale, 0, 1200); cy = clamp(drag.cy - (event.clientY - drag.y) / scale, 0, 840); paint(); });
    function release() { drag = null; viewport.classList.remove('is-dragging'); }
    on(viewport, 'pointerup', release);
    on(viewport, 'pointercancel', release);
    on(viewport, 'lostpointercapture', release);
    on(viewport, 'keydown', event => {
        if (event.target.closest('button'))
            return;
        const step = 50 / (base * zoom);
        if (event.key === 'ArrowLeft')
            cx = clamp(cx - step, 0, 1200);
        else if (event.key === 'ArrowRight')
            cx = clamp(cx + step, 0, 1200);
        else if (event.key === 'ArrowUp')
            cy = clamp(cy - step, 0, 840);
        else if (event.key === 'ArrowDown')
            cy = clamp(cy + step, 0, 840);
        else if (event.key === '+' || event.key === '=')
            changeZoom(1.25);
        else if (event.key === '-')
            changeZoom(.8);
        else if (event.key === 'Home')
            overview();
        else
            return;
        event.preventDefault();
        render();
    });
    new ResizeObserver(resize).observe(viewport);
    selectPlace(data[0].id, false);
    resize();
})();
'use strict';
(() => {
    const $ = id => document.getElementById(id), panel = $('city-heist'), products = JSON.parse($('product-data').textContent), assets = "";
    const loot = { 'the-vault': ['manette-black', 'manette-violet'], 'port-zero': ['tapis-black', 'tapis-violet'] };
    const action = $('heist-action'), picker = $('heist-product-select'), calm = $('heist-calm'), cursor = $('heist-cursor'), status = $('heist-status');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    calm.checked = reduced.matches;
    let place = $('city-place-select').value, site = null, product = null, phase = 'idle', beats = 0, position = 0, origin = 0, animation = null;
    function stop() { if (animation !== null)
        cancelAnimationFrame(animation); animation = null; }
    function navigate(id, route = false) { document.dispatchEvent(new CustomEvent('city:navigate', { detail: { id, route } })); }
    function announce(message) { status.textContent = message; }
    function productView() {
        product = products.find(p => p.key === picker.value);
        if (!product)
            return;
        const image = product.category === L("s_0cfe663015a9") ? (product.images.find(i => i[1] === L("s_f364d779466c")) || product.images[0]) : product.images[0];
        $('heist-product-image').src = image[0];
        $('heist-product-image').alt = image[2];
        $('heist-product-name').textContent = product.name;
        const link = $('heist-product-link');
        link.href = '#' + product.key;
        link.dataset.select = product.key;
        link.textContent = L("s_b9cd079e8c27") + product.name + L("s_7d0da37bafe1");
    }
    function target(id) { document.querySelectorAll('[data-place]').forEach(pin => pin.classList.toggle('is-heist-target', pin.dataset.place === id)); }
    function render() {
        panel.dataset.phase = phase;
        const mission = Boolean(loot[place]) || phase !== 'idle';
        $('heist-teaser').hidden = mission;
        $('heist-mission').hidden = !mission;
        $('city-place-card').dataset.heist = String(mission);
        panel.setAttribute('aria-labelledby', mission ? 'heist-product-name' : 'heist-title');
        if (!mission)
            return;
        const active = ['playing', 'retry', 'paused', 'return', 'escaping'].includes(phase), won = phase === 'success';
        $('heist-picker-label').hidden = phase !== 'idle';
        $('heist-calm-label').hidden = phase !== 'idle';
        $('heist-game').hidden = !['playing', 'retry', 'paused'].includes(phase) || calm.checked;
        $('heist-cancel').hidden = !active;
        $('heist-product-link').hidden = !won;
        action.hidden = false;
        $('heist-stage').textContent = won ? L("s_f376c1d756e9") : phase === 'return' ? L("s_96e5888207b8") : phase === 'idle' ? L("s_2aa9ccef4ee2") : L("s_e3c122999922");
        const step = won ? 3 : phase === 'return' ? 2 : phase === 'idle' ? 0 : 1;
        document.querySelectorAll('[data-heist-step]').forEach((el, i) => { el.classList.toggle('is-current', i === step); el.classList.toggle('is-done', i < step); if (i === step)
            el.setAttribute('aria-current', 'step');
        else
            el.removeAttribute('aria-current'); });
        $('heist-beats').textContent = beats + L("s_4db50a4116c2");
        $('heist-instruction').textContent = won ? L("s_0bf65867d09c") : phase === 'return' ? L("s_97c396c4e772") : phase === 'idle' ? L("s_bb48b78ab523") : calm.checked ? L("s_8cbf791f0ebd") : L("s_279833dd2821");
        action.textContent = won ? L("s_b237659b7276") : phase === 'return' ? L("s_69f933ff1008") : phase === 'retry' ? L("s_0b4dc1edd5f7") : phase === 'paused' ? L("s_3583b27e2bc2") : phase === 'idle' ? L("s_496c2ca39adb") : calm.checked ? L("s_e847bcf7de21") : L("s_c8e44ab9c79b");
    }
    function finishEscape() { phase = 'return'; target('le-refuge'); render(); announce(L("s_e91dd6671a82") + product.name + L("s_27b327f12c43")); action.focus({ preventScroll: true }); }
    on(document, 'criminal:escape-complete', () => { if (phase === 'escaping')
        finishEscape(); });
    const renderMission = render;
    render = function () { renderMission(); if (phase === 'escaping') {
        action.hidden = true;
        $('heist-game').hidden = true;
        $('heist-stage').textContent = L("s_e333e1aca460");
        $('heist-instruction').textContent = L("s_b7fa3bab43ca");
    } };
    function prepare(id) {
        if (!loot[id])
            return;
        const previous = picker.value;
        site = id;
        picker.replaceChildren(...loot[id].map(key => { const option = document.createElement('option'); option.value = key; option.textContent = products.find(p => p.key === key).name; return option; }));
        const sameColor = loot[id].find(key => previous && key.split('-').at(-1) === previous.split('-').at(-1));
        if (sameColor)
            picker.value = sameColor;
        productView();
    }
    function tick(now) { position = ((now - origin) % 3600) / 3600; position = position <= .5 ? position * 2 : 2 - position * 2; cursor.style.left = (position * 100) + '%'; animation = requestAnimationFrame(tick); }
    function play() { stop(); phase = 'playing'; position = 0; origin = performance.now(); cursor.style.left = '0%'; render(); if (!calm.checked)
        animation = requestAnimationFrame(tick); }
    function reset(message = '') {
        document.dispatchEvent(new Event('criminal:escape-cancel'));
        stop();
        phase = 'idle';
        beats = 0;
        target(null);
        if (loot[place])
            prepare(place);
        render();
        announce(message);
    }
    document.querySelectorAll('[data-heist-site]').forEach(button => on(button, 'click', () => { reset(); navigate(button.dataset.heistSite); action.focus({ preventScroll: true }); panel.scrollIntoView({ block: 'nearest', behavior: reduced.matches ? 'instant' : 'smooth' }); }));
    on(picker, 'change', () => { productView(); announce(''); });
    on(action, 'click', () => {
        if (phase === 'success') {
            reset();
            navigate(site);
            action.focus({ preventScroll: true });
            return;
        }
        if (phase === 'return') {
            navigate('le-refuge');
            return;
        }
        if (phase === 'idle') {
            site = place;
            beats = 0;
            phase = 'playing';
            navigate(site, true);
            target(site);
            announce(calm.checked ? L("s_00758f06f428") : L("s_480ff89ff684"));
            play();
            return;
        }
        if (phase === 'paused' || phase === 'retry') {
            announce(L("s_13334a942802"));
            play();
            return;
        }
        if (phase !== 'playing')
            return;
        if (!calm.checked && (position < .32 || position > .68)) {
            stop();
            phase = 'retry';
            render();
            announce(L("s_f7ecafee5bf9"));
            return;
        }
        beats = calm.checked ? 2 : beats + 1;
        if (beats < 2) {
            announce(L("s_490c85c066bb"));
            play();
            return;
        }
        stop();
        if (calm.checked) {
            finishEscape();
            return;
        }
        phase = 'escaping';
        render();
        announce(L("s_53a4befc1d06") + product.name + '. Semez les poursuivants sur la carte.');
        document.dispatchEvent(new CustomEvent('criminal:escape', { detail: { site, product: product.name } }));
    });
    on($('heist-cancel'), 'click', () => { reset(L("s_506dc9e808ae")); action.focus({ preventScroll: true }); });
    on(document, 'city:placechange', event => {
        place = event.detail.id;
        if (phase === 'return' && place === 'le-refuge') {
            stop();
            phase = 'success';
            target(null);
            render();
            announce(L("s_d71d9f5709c9") + product.name + L("s_6e7729a9faf6"));
            $('heist-product-link').focus({ preventScroll: true });
            panel.scrollIntoView({ block: 'nearest', behavior: reduced.matches ? 'instant' : 'smooth' });
            return;
        }
        if (phase === 'success') {
            if (place !== 'le-refuge')
                reset();
            else
                render();
            return;
        }
        if (phase !== 'idle' && place !== site) {
            reset(L("s_af1a9b7d24ca"));
            return;
        }
        if (phase === 'idle' && loot[place])
            prepare(place);
        render();
    });
    on(document, 'visibilitychange', () => { if (document.hidden && phase === 'playing' && !calm.checked) {
        stop();
        phase = 'paused';
        render();
        announce(L("s_4575ad96cd2a"));
    } });
    on(reduced, 'change', event => { if (event.matches) {
        calm.checked = true;
        if (phase === 'playing') {
            stop();
            render();
            announce(L("s_9f0e9f676781"));
        }
    } });
    addEventListener('pagehide', stop);
    if (loot[place])
        prepare(place);
    render();
})();
'use strict';
(() => {
    const geometry = { "front": { "width": 1254, "height": 1254, "target": { "cx": 627, "cy": 627, "w": 1140 }, "sunset": { "x": 24, "y": 185, "w": 1215, "h": 929 }, "gangsta": { "x": 78, "y": 207, "w": 1114, "h": 853 } }, "hero": { "width": 1050, "height": 1050, "target": { "cx": 548.366141, "cy": 629.584781, "w": 722.28697 }, "sunset": { "width": 1050, "height": 1050, "x": 131.94948187499998, "y": 164.448576125, "w": 827.5319551250001, "h": 762.0430596250001 }, "gangsta": { "width": 1050, "height": 1050, "x": 187.22265600000003, "y": 326.09431200000006, "w": 722.28697, "h": 606.9809379999999 } } }, registered = new WeakSet(), pending = new Set();
    let frame = null;
    const px = value => Number.parseFloat(value) || 0;
    function source(image) {
        if (image.id === 'hero-city-violet')
            return { group: geometry.hero, box: geometry.hero.sunset };
        if (image.id === 'hero-city-black')
            return { group: geometry.hero, box: geometry.hero.gangsta };
        const name = (image.getAttribute('src') || '').split('/').pop().split('?')[0];
        if (/^lexip-criminal-manette-violet-transparent\.(webp|png)$/.test(name))
            return { group: geometry.front, box: geometry.front.sunset };
        if (/^lexip-criminal-manette-black-transparent\.(webp|png)$/.test(name))
            return { group: geometry.front, box: geometry.front.gangsta };
        return null;
    }
    function align(image) {
        const config = source(image);
        if (!config) {
            image.classList.remove('controller-normalized');
            for (const key of ['--controller-scale', '--controller-x', '--controller-y'])
                image.style.removeProperty(key);
            return;
        }
        if (!image.clientWidth || !image.clientHeight)
            return;
        const style = getComputedStyle(image), left = px(style.paddingLeft), top = px(style.paddingTop), width = image.clientWidth - left - px(style.paddingRight), height = image.clientHeight - top - px(style.paddingBottom);
        const { group, box } = config;
        if (group === geometry.hero) {
            const parent = image.parentElement, side = Math.max(parent.clientWidth, parent.clientHeight);
            if (!side)
                return;
            const position = style.objectPosition.split(' ').map(value => px(value) / 100), fit = side / group.width;
            image.style.width = side + 'px';
            image.style.height = side + 'px';
            image.style.left = ((parent.clientWidth - side) * (position[0] ?? .5)) + 'px';
            image.style.top = ((parent.clientHeight - side) * (position[1] ?? .5)) + 'px';
            const scale = group.target.w / box.w, origin = side / 2;
            image.style.setProperty('--controller-scale', String(scale));
            image.style.setProperty('--controller-x', (group.target.cx * fit - origin - scale * ((box.x + box.w / 2) * fit - origin)) + 'px');
            image.style.setProperty('--controller-y', (group.target.cy * fit - origin - scale * ((box.y + box.h / 2) * fit - origin)) + 'px');
            image.classList.add('controller-normalized');
            return;
        }
        const fit = style.objectFit === 'cover' ? Math.max(width / group.width, height / group.height) : Math.min(width / group.width, height / group.height);
        const position = style.objectPosition.split(' ').map(value => px(value) / 100), imageWidth = group.width * fit, imageHeight = group.height * fit;
        const offsetX = px(style.borderLeftWidth) + left + (width - imageWidth) * (position[0] ?? .5), offsetY = px(style.borderTopWidth) + top + (height - imageHeight) * (position[1] ?? .5);
        const presentation = px(style.getPropertyValue('--controller-presentation-scale')) || 1;
        const scale = group.target.w / box.w * presentation, originX = image.offsetWidth / 2, originY = image.offsetHeight / 2;
        const sourceX = offsetX + (box.x + box.w / 2) * fit, sourceY = offsetY + (box.y + box.h / 2) * fit;
        const targetX = offsetX + group.target.cx * fit, targetY = offsetY + group.target.cy * fit;
        image.style.setProperty('--controller-scale', String(scale));
        image.style.setProperty('--controller-x', (targetX - originX - scale * (sourceX - originX)) + 'px');
        image.style.setProperty('--controller-y', (targetY - originY - scale * (sourceY - originY)) + 'px');
        image.classList.add('controller-normalized');
    }
    function schedule(image) { pending.add(image); if (frame === null)
        frame = requestAnimationFrame(() => { frame = null; for (const item of pending)
            align(item); pending.clear(); }); }
    const resize = new ResizeObserver(entries => entries.forEach(entry => { if (entry.target.matches('img'))
        schedule(entry.target);
    else
        entry.target.querySelectorAll('.hero-city').forEach(schedule); }));
    function register(image) { if (image.matches('.hero-city') && CSS.supports('width', '1cqw')) return; if (registered.has(image)) {
        schedule(image);
        return;
    } registered.add(image); on(image, 'load', () => schedule(image)); resize.observe(image); if (image.matches('.hero-city'))
        resize.observe(image.parentElement); schedule(image); }
    document.querySelectorAll('img').forEach(register);
    new MutationObserver(records => { for (const record of records) {
        if (record.type === 'attributes' && record.target.matches('img'))
            register(record.target);
        for (const node of record.addedNodes) {
            if (node.nodeType !== 1)
                continue;
            if (node.matches('img'))
                register(node);
            node.querySelectorAll('img').forEach(register);
        }
    } }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });
    addEventListener('resize', () => document.querySelectorAll('img.controller-normalized').forEach(schedule));
})();
'use strict';
(() => {
    const viewport = document.getElementById('city-viewport'), world = document.getElementById('city-world');
    if (!viewport || !world)
        return;
    const layer = document.createElement('div');
    layer.className = 'escape-layer';
    layer.hidden = true;
    layer.setAttribute('role', 'group');
    layer.setAttribute('aria-label', L("s_106b868ca918"));
    layer.innerHTML = L("s_f016b7d12b63");
    viewport.append(layer);
    const player = layer.querySelector('.escape-player'), route = layer.querySelector('.escape-route'), readout = layer.querySelector('.escape-readout'), meter = layer.querySelector('.escape-meter i'), notice = layer.querySelector('.escape-notice'), pause = layer.querySelector('.escape-pause');
    const hud = layer.querySelector('.escape-hud');
    hud.hidden = true;
    viewport.before(hud);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let active = false, running = false, starting = false, inView = true, frame = null, last = 0, elapsed = 0, heat = 0, hits = 0, path = [], enemies = [], lastShot = -1, lastPaint = 0, failed = false;
    const duration = 16;
    for (let i = 0; i < 3; i++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'escape-target';
        button.setAttribute('aria-label', L("s_3f001a3dcf41") + (i + 1));
        button.innerHTML = '<span>' + (i + 1) + '</span>';
        layer.append(button);
        on(button, 'click', () => shoot(i));
    }
    const targets = [...layer.querySelectorAll('.escape-target')];
    function stop() { if (frame !== null)
        cancelAnimationFrame(frame); frame = null; last = 0; }
    function message(text) { notice.textContent = text; }
    function close() { stop(); active = running = starting = false; layer.hidden = true; hud.hidden = true; viewport.classList.remove('is-escaping'); }
    function complete() { close(); document.dispatchEvent(new Event('criminal:escape-complete')); }
    function point(t) {
        const lengths = path.slice(1).map((p, i) => Math.hypot(p[0] - path[i][0], p[1] - path[i][1])), total = lengths.reduce((a, b) => a + b, 0);
        let distance = Math.min(1, t) * total;
        for (let i = 0; i < lengths.length; i++) {
            if (distance <= lengths[i] || i === lengths.length - 1) {
                const r = distance / lengths[i];
                return { x: path[i][0] + (path[i + 1][0] - path[i][0]) * r, y: path[i][1] + (path[i + 1][1] - path[i][1]) * r };
            }
            distance -= lengths[i];
        }
    }
    function paint() {
        const matrix = new DOMMatrix(getComputedStyle(world).transform), p = point(elapsed / duration), screen = (x, y) => ({ x: matrix.a * x + matrix.e, y: matrix.d * y + matrix.f });
        route.style.transform = world.style.transform;
        const pos = screen(p.x, p.y);
        player.style.transform = 'translate(' + (pos.x - 8) + 'px,' + (pos.y - 8) + 'px)';
        enemies.forEach((e, i) => { const q = screen(e.x, e.y); targets[i].style.transform = 'translate(' + (q.x - 22) + 'px,' + (q.y - 22) + 'px)'; targets[i].classList.toggle('is-stunned', elapsed < e.stun); });
        readout.textContent = Math.ceil(duration - elapsed) + L("s_994a0757103e") + Math.round(heat) + ' % · ' + hits + L("s_b2496dddbfff");
        meter.style.width = (elapsed / duration * 100) + '%';
    }
    function shoot(i) {
        if (!active || !running || elapsed - lastShot < .18)
            return;
        const e = enemies[i];
        if (elapsed < e.stun)
            return;
        lastShot = elapsed;
        e.stun = elapsed + 2.8;
        hits++;
        heat = Math.max(0, heat - 12);
        message(L("s_3e6a8dfd879c") + (i + 1) + L("s_494aefd23afe"));
        paint();
    }
    function tick(now) {
        frame = null;
        if (!active || !running)
            return;
        const dt = last ? Math.min((now - last) / 1000, .06) : 0;
        last = now;
        elapsed = Math.min(duration, elapsed + dt);
        const p = point(elapsed / duration);
        let nearby = 0;
        enemies.forEach((e, i) => { if (elapsed < e.stun)
            return; const offsets = [[-105, 0], [105, 0], [0, 120]], dx = p.x + offsets[i][0] - e.x, dy = p.y + offsets[i][1] - e.y, d = Math.hypot(dx, dy); if (d > 1) {
            const step = Math.min(d, 76 * dt);
            e.x += dx / d * step;
            e.y += dy / d * step;
        } if (Math.hypot(p.x - e.x, p.y - e.y) < 145)
            nearby++; });
        heat = Math.max(0, Math.min(100, heat + (nearby ? nearby * 3 : -5) * dt));
        if (heat >= 100) {
            running = false;
            failed = true;
            stop();
            pause.textContent = L("s_e0a7d289763e");
            message(L("s_c85fbf4d76e4"));
            paint();
            pause.focus({ preventScroll: true });
            return;
        }
        if (elapsed >= duration) {
            message(L("s_471c4b501795"));
            complete();
            return;
        }
        if (now - lastPaint > 33) {
            paint();
            lastPaint = now;
        }
        frame = requestAnimationFrame(tick);
    }
    function resume() { if (!active || !inView || document.hidden) {
        pause.textContent = document.documentElement.lang==='de'?'Fortsetzen':document.documentElement.lang==='en'?'Resume':'Reprendre';
        return;
    } running = true; starting = false; pause.textContent = 'Pause'; last = 0; stop(); frame = requestAnimationFrame(tick); }
    function suspend() { if (!active || !running)
        return; running = false; stop(); pause.textContent = document.documentElement.lang==='de'?'Fortsetzen':document.documentElement.lang==='en'?'Resume':'Reprendre'; message(L("s_5a85c3173705")); }
    function restart() { elapsed = heat = hits = 0; lastShot = -1; failed = false; starting = true; const p = path[0]; enemies = [{ x: p[0] - 170, y: p[1], stun: 0 }, { x: p[0] + 150, y: p[1] + 90, stun: 0 }, { x: p[0], y: p[1] + 190, stun: 0 }]; message(L("s_291eb9742903")); paint(); resume(); }
    on(pause, 'click', () => { if (failed)
        restart();
    else if (running)
        suspend();
    else
        resume(); });
    on(hud.querySelector('.escape-skip'), 'click', complete);
    on(layer, 'pointerdown', event => event.stopPropagation());
    on(layer, 'keydown', event => { if (['1', '2', '3'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        shoot(Number(event.key) - 1);
    } });
    on(hud, 'keydown', event => { if (['1', '2', '3'].includes(event.key)) {
        event.preventDefault();
        shoot(Number(event.key) - 1);
    } });
    on(document, 'criminal:escape', event => {
        close();
        if (reduced.matches) {
            document.dispatchEvent(new Event('criminal:escape-complete'));
            return;
        }
        path = event.detail.site === 'port-zero' ? [[760, 660], [600, 660], [600, 540], [440, 540], [440, 660], [280, 660]] : [[600, 180], [440, 180], [440, 420], [280, 420], [280, 660]];
        route.querySelector('polyline').setAttribute('points', path.map(p => p.join(',')).join(' '));
        active = true;
        layer.hidden = false;
        hud.hidden = false;
        viewport.classList.add('is-escaping');
        document.getElementById('city-reset').click();
        viewport.scrollIntoView({ block: 'center', behavior: 'instant' });
        restart();
        pause.focus({ preventScroll: true });
    });
    on(document, 'criminal:escape-cancel', close);
    on(document, 'visibilitychange', () => { if (document.hidden)
        suspend(); });
    new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (!inView)
        suspend();
    else if (active && starting)
        resume(); }, { threshold: .15 }).observe(viewport);
    new ResizeObserver(() => { if (active) {
        document.getElementById('city-reset').click();
        paint();
    } }).observe(viewport);
    on(reduced, 'change', () => { if (reduced.matches && active)
        complete(); });
    addEventListener('pagehide', close);
})();
'use strict';
(() => {
    const drawer = document.getElementById('city-mission-drawer'), panel = document.getElementById('city-heist');
    on(document, 'city:placechange', event => queueMicrotask(() => {
        drawer.open = event.detail.kind === 'score' || panel.dataset.phase !== 'idle';
    }));
})();
'use strict';
(() => {
    const explorer = document.getElementById('explorer'), picker = explorer.querySelector('.product-picker'), header = document.querySelector('.site-header');
    function offsets() { explorer.style.setProperty('--site-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px'); explorer.style.setProperty('--product-picker-height', Math.ceil(picker.getBoundingClientRect().height) + 'px'); }
    const resize = new ResizeObserver(offsets);
    resize.observe(header);
    resize.observe(picker);
    offsets();
})();
'use strict';
(() => {
    const discovery = document.getElementById('city-discovery'), mobile = matchMedia('(max-width:760px)');
    function mode() { discovery.open = !mobile.matches; }
    on(mobile, 'change', mode);
    mode();
    document.querySelectorAll('a[href="#la-ville"]').forEach(link => on(link, 'click', () => { discovery.open = true; }));
})();
'use strict';
(() => {
    const mobile = matchMedia('(max-width:760px)');
    const panels = [...document.querySelectorAll('#explorer .product-panel')].map(panel => {
        const gallery = panel.querySelector('.product-gallery'), heading = panel.querySelector('.purchase-summary h3');
        const origin = document.createComment(L("s_9f43f2142c46"));
        gallery.before(origin);
        return { gallery, heading, origin };
    });
    function layout() {
        for (const { gallery, heading, origin } of panels) {
            if (mobile.matches)
                heading.after(gallery);
            else
                origin.after(gallery);
        }
        document.getElementById('explorer').classList.toggle('mobile-product-layout', mobile.matches);
    }
    on(mobile, 'change', layout);
    layout();
})();
if (!config.mapEnabled)
    document.getElementById("la-ville").hidden = true;
if (!config.radioEnabled) {
    document.getElementById("radio-widget").hidden = true;
    document.getElementById("criminal-radio-audio").removeAttribute("src");
}
   return ()=>{
    stopHeroMotion();radioTrack.pause();radioTrack.remove();
    for(const id of timers)window.clearTimeout(id);
    for(const id of frames)window.cancelAnimationFrame(id);
    for(const fn of cleanup)fn();
   };
  })();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
 document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('#lexip-criminal-root'))mount();});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('#lexip-criminal-root')&&dispose){dispose();dispose=null;}});
})();
